import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShoppingCart, Heart, ChevronRight, Home } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { CartSidebar } from '../components/CartSidebar';
import { CartItem, Page } from '../App';
const applianceProducts = [{
  id: 'a1',
  name: 'Smart TV 55"',
  price: 285000,
  originalPrice: 320000,
  image: 'https://images.unsplash.com/photo-1593784991095-a20506948430?auto=format&fit=crop&q=80&w=800',
  rating: 4.8,
  badge: 'Best Seller',
  weight: 12.0,
  sku: 'APPL-STV-001',
  description: '4K UHD Smart TV with Android OS, 3 HDMI ports'
}, {
  id: 'a2',
  name: 'Blender Pro 2000',
  price: 32000,
  image: 'https://images.unsplash.com/photo-1570222094114-28a9d88a2d64?auto=format&fit=crop&q=80&w=800',
  rating: 4.6,
  weight: 2.5,
  sku: 'APPL-BLP-002',
  description: '2000W high-speed blender with 6 stainless steel blades'
}, {
  id: 'a3',
  name: 'Air Fryer XL 5.5L',
  price: 48000,
  image: 'https://images.unsplash.com/photo-1585515320310-259814833e62?auto=format&fit=crop&q=80&w=800',
  rating: 4.9,
  badge: 'New Arrival',
  weight: 4.2,
  sku: 'APPL-AFX-003',
  description: 'Digital air fryer, 5.5L capacity, 8 cooking presets'
}, {
  id: 'a4',
  name: 'Microwave Oven 30L',
  price: 65000,
  image: 'https://images.unsplash.com/photo-1574269909862-7e1d70bb8078?auto=format&fit=crop&q=80&w=800',
  rating: 4.7,
  weight: 11.0,
  sku: 'APPL-MWO-004',
  description: '30L digital microwave with grill function, 900W'
}, {
  id: 'a5',
  name: 'Standing Fan 18"',
  price: 28000,
  image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&q=80&w=800',
  rating: 4.5,
  weight: 3.8,
  sku: 'APPL-STF-005',
  description: 'Oscillating standing fan, 3-speed settings, remote control'
}, {
  id: 'a6',
  name: 'Rice Cooker 1.8L',
  price: 22000,
  image: 'https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&q=80&w=800',
  rating: 4.6,
  weight: 2.0,
  sku: 'APPL-RCK-006',
  description: 'Automatic rice cooker with keep-warm function'
}, {
  id: 'a7',
  name: 'Electric Kettle 1.7L',
  price: 15000,
  originalPrice: 18000,
  image: 'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?auto=format&fit=crop&q=80&w=800',
  rating: 4.7,
  badge: 'Sale',
  weight: 1.2,
  sku: 'APPL-EKT-007',
  description: 'Stainless steel electric kettle, 1500W, auto shut-off'
}, {
  id: 'a8',
  name: 'Washing Machine 7kg',
  price: 185000,
  image: 'https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?auto=format&fit=crop&q=80&w=800',
  rating: 4.8,
  weight: 52.0,
  sku: 'APPL-WMC-008',
  description: 'Front-load washing machine, 7kg capacity, 1200 RPM'
}];
interface PageProps {
  onAddToCart: (product: Omit<CartItem, 'quantity'>) => void;
  onNavigate: (page: Page) => void;
  cartItems: CartItem[];
  cartCount: number;
  isCartOpen: boolean;
  onOpenCart: () => void;
  onCloseCart: () => void;
  onUpdateQuantity: (id: string, delta: number) => void;
  onRemoveItem: (id: string) => void;
}
export function HomeAppliancesPage({
  onAddToCart,
  onNavigate,
  cartItems,
  cartCount,
  isCartOpen,
  onOpenCart,
  onCloseCart,
  onUpdateQuantity,
  onRemoveItem
}: PageProps) {
  const formatCurrency = (amount: number) => new Intl.NumberFormat('en-NG', {
    style: 'currency',
    currency: 'NGN',
    minimumFractionDigits: 0
  }).format(amount);
  return <div className="bg-[#0F0F0F] min-h-screen text-white" data-id="element-518">
      <Navbar onOpenCart={onOpenCart} cartCount={cartCount} onNavigate={onNavigate} data-id="element-519" />

      <div className="pt-28 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-520">
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-6" data-id="element-521">
          <button onClick={() => onNavigate('home')} className="hover:text-[#D4AF37] transition-colors" data-id="element-522">
            Home
          </button>
          <ChevronRight className="w-4 h-4" data-id="element-523" />
          <span className="text-[#00FF87]" data-id="element-524">Home Appliances</span>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center gap-4 mb-4" data-id="element-525">
          <div className="p-3 bg-[#00FF87]/10 rounded-xl" data-id="element-526">
            <Home className="w-7 h-7 text-[#00FF87]" data-id="element-527" />
          </div>
          <div data-id="element-528">
            <h1 className="text-4xl md:text-5xl font-bold font-serif text-white" data-id="element-529">
              Home Appliances
            </h1>
            <p className="text-gray-400 mt-1" data-id="element-530">
              Quality appliances for the modern Nigerian home
            </p>
          </div>
        </motion.div>
      </div>

      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto pb-24" data-id="element-531">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-532">
          {applianceProducts.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.07
        }} className="glass-card rounded-xl overflow-hidden group flex flex-col" data-id="element-533">
              <div className="relative h-56 overflow-hidden" data-id="element-534">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-535" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" data-id="element-536" />
                {product.badge && <span className="absolute top-3 left-3 bg-[#00FF87] text-black text-xs font-bold px-2 py-1 rounded" data-id="element-537">
                    {product.badge}
                  </span>}
                <button className="absolute top-3 right-3 p-2 bg-white/10 backdrop-blur-sm text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-white hover:text-black" data-id="element-538">
                  <Heart className="w-4 h-4" data-id="element-539" />
                </button>
              </div>
              <div className="p-4 flex-1 flex flex-col" data-id="element-540">
                <p className="text-xs text-gray-500 mb-1" data-id="element-541">SKU: {product.sku}</p>
                <h3 className="text-white font-medium mb-1 line-clamp-1" data-id="element-542">
                  {product.name}
                </h3>
                <p className="text-gray-500 text-xs mb-3 line-clamp-2" data-id="element-543">
                  {product.description}
                </p>
                <div className="flex items-center gap-1 mb-3" data-id="element-544">
                  <Star className="w-3 h-3 text-[#D4AF37] fill-[#D4AF37]" data-id="element-545" />
                  <span className="text-xs text-gray-400" data-id="element-546">
                    {product.rating}
                  </span>
                  <span className="text-xs text-gray-600 ml-1" data-id="element-547">
                    · {product.weight}kg
                  </span>
                </div>
                <div className="mt-auto flex items-center justify-between" data-id="element-548">
                  <div data-id="element-549">
                    <span className="text-lg font-bold text-white" data-id="element-550">
                      {formatCurrency(product.price)}
                    </span>
                    {product.originalPrice && <p className="text-xs text-gray-500 line-through" data-id="element-551">
                        {formatCurrency(product.originalPrice)}
                      </p>}
                  </div>
                  <button onClick={() => onAddToCart(product)} className="p-3 bg-white/10 hover:bg-[#00FF87] hover:text-black text-white rounded-lg transition-colors" data-id="element-552">
                    <ShoppingCart className="w-4 h-4" data-id="element-553" />
                  </button>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>

      <Footer onNavigate={onNavigate} data-id="element-554" />
      <CartSidebar isOpen={isCartOpen} onClose={onCloseCart} items={cartItems} onUpdateQuantity={onUpdateQuantity} onRemoveItem={onRemoveItem} onNavigate={onNavigate} data-id="element-555" />
    </div>;
}